<template>
  <v-dialog
    v-model="dialogVisible"
    v-bind="$attrs"
    class="roundedcorners ma-3 pa-3"
    :width="options.width"
    :height="options.height"
    :min-width="isOnMobile ? options.minWidthMobile : options.minWidth"
    :min-height="options.minHeight"
    v-bind:style="{ zIndex: options.zIndex }"
  >
    <v-card
      :color="options.color"
      :width="options.width"
      :height="options.height"
      :min-width="options.minWidth"
      :min-height="options.minHeight"
      class="ma-0 pa-2"
      dark
      align="center"
      justify="center"
    >
      <v-card-text class="ma-0 pa-4">
        <span>{{ message }}</span>
        <v-spacer></v-spacer>
      </v-card-text>
      <v-progress-circular v-if="circular" indeterminate size="40" width="8" class="ma-0 pa-2"></v-progress-circular>
      <v-progress-linear v-else indeterminate striped color="white" class="roundedcorners ma-0 pa-2"></v-progress-linear>
    </v-card>
  </v-dialog>

  <v-dialog v-model="snackbarVisible" v-bind="$attrs" persistent class="routercontainer text-center">
    <v-container class="fill-height">
      <v-snackbar
        v-model="snackbarVisible"
        :absolute="true"
        :color="snackbar.color"
        :location="snackbar.location"
        :timeout="snackbar.timeout"
        :multi-line="snackbar.mode === 'multi-line'"
        :width="options.width"
        :min-width="isOnMobile ? options.minWidthMobile : options.minWidth"
        :vertical="snackbar.mode === 'vertical'"
      >
        <v-row class="ma-0 pa-0 box-container-horizontal" justify="space-between" align="center">
          <div class="ma-0 pa-0 row-content" v-if="snackbar.message">
            <v-row class="ma-0 pa-0" style="width: 100%" v-for="(msg, idx) in snackbar.message.split('\n')" :key="idx">
              <a v-if="msg.startsWith('tel:')" class="ma-0 pa-2" :style="'width: 100%; color: ' + snackbar.colorFont" :href="msg" target="_blank">{{
                msg.replace("tel:", "")
              }}</a>
              <span v-else class="ma-0 pa-2" :style="'width: 100%; color: ' + snackbar.colorFont">{{ msg }}</span>
            </v-row>
          </div>
          <div class="row-header" align="start">
            <v-btn icon="mdi-close" density="compact" :color="snackbar.close.color" @click="hideSnackbar()"> </v-btn>
          </div>
        </v-row>
      </v-snackbar>
    </v-container>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      circular: false,
      message: null,
      options: {
        color: "",
        width: "unset",
        height: "unset",
        minWidth: 320,
        minWidthMobile: 320,
        minHeight: 100,
        zIndex: 20000,
      },
      snackbarVisible: false,
      snackbar: {
        enabled: false,
        color: "grey lighten-4",
        colorFont: "#000",
        mode: "multi-line",
        timeout: 5000,
        message: "Success!",
        callback: null,
        location: "center",
        close: {
          text: "Close",
          color: "black",
        },
      },
    };
  },
  methods: {
    show: function (message, options) {
      this.message = message;
      this.options = Object.assign(this.options, options);
      this.dialogVisible = true;
    },
    hide: function () {
      this.dialogVisible = false;
    },
    hideSnackbar: function () {
      if (this.snackbar.callback) {
        this.snackbar.callback();
      }
      this.snackbarVisible = false;
    },
    showSnackbar: function (message, snackbarOptions) {
      if (message) {
        this.snackbar.message = message;
      }
      this.snackbar = Object.assign(this.snackbar, snackbarOptions);
      this.snackbar.enabled = true;
      this.snackbarVisible = true;
    },
    showError: function (message, snackbarOptions) {
      this.snackbar.location = "center";
      this.showSnackbar(
        message,
        Object.assign(
          {
            color: "red lighten-4",
            timeout: 5000,
            colorFont: this.isInDarkMode ? "#FFF" : "#000",
          },
          snackbarOptions
        )
      );
    },
    showInfo: function (message, snackbarOptions) {
      this.snackbar.location = "center";
      this.showSnackbar(
        message,
        Object.assign(
          {
            color: this.Colors.ActiveItemBackground, // this.isInDarkMode ? "grey darken-5" : "grey lighten-4",
            colorFont: this.isInDarkMode ? "#FFF" : "#000",
            timeout: 5000,
          },
          snackbarOptions
        )
      );
    },
  },
  mounted() {
    this.dialog.showError = this.showError;
    this.dialog.showInfo = this.showInfo;
  },
};
</script>

<style scoped>
.roundedcorners {
  border-radius: 5px;
}

div >>> v-snack__content {
  width: unset;
}
</style>